import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { from, Observable, switchMap } from 'rxjs';

/**
 * Opens the (lazy-loaded) legal-document / NDA dialog and returns its `afterClosed()`.
 * The dialog carries pdf.js (~1 MB) - importing it dynamically keeps that out of
 * the initial bundle; it loads the first time a user needs to view a legal PDF.
 */
export function openLegalDocumentDialog(dialog: MatDialog, config?: MatDialogConfig): Observable<any> {
  return from(import('./legal-document-dialog.component')).pipe(
    switchMap(m => dialog.open(m.LegalDocumentDialogComponent, config).afterClosed())
  );
}
